import Spinner from './spinner-view'

export default Spinner
